/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class PermissionGuard
 */
import { Guard, GuardResult } from 'vue-router-guards';
import { Route } from 'vue-router';
import { Store } from 'vuex';

export class PermissionGuard implements Guard {
  private readonly store: Store<unknown>;

  constructor(store: Store<unknown>) {
    this.store = store;
  }

  public async execute(to: Route, _from: Route): Promise<GuardResult> {
    const permissionAlias = to.meta.PermissionAlias;
    const hasAccess: boolean = permissionAlias
      ? this.store.getters['dashboard/permissions/HasAccess'](permissionAlias)
      : true;
    return new GuardResult(hasAccess, '/');
  }
}
